

export default class NotificationTranslationsRequest  {
	Text?: string = '';
	Title?: string = '';
	LangCode?: string = '';
	constructor(obj?: Partial<NotificationTranslationsRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
